// affects number formatting (thousands separator, decimal separator)
// defaults to "," for thousands and "." for decimal
export const CURRENCY_NUMBER_FORMAT_LOCALE: Record<string, string> = {
  IDR: "id",
  VND: "vi",
  BRL: "pt-BR",
  RUB: "ru",
  CZK: "cs",
  RON: "ro",
  UAH: "uk",
  CLP: "es-CL",
  COP: "es-CO",
  UYU: "es-UY",
  ARS: "es-AR",
  INR: "hi-IN",
  NPR: "hi-IN",
  LKR: "hi-IN",
  BDT: "hi-IN",
};

// Heavily modified from https://gist.github.com/ksafranski/2973986
// checked against https://documentation.infiniteblue.com/platform/Currency_formats.htm
export const CURRENCY_SYMBOLS: Record<string, string> = {
  USD: "US$",
  CAD: "CA$",
  EUR: "€",
  AFN: "؋",
  ALL: "Lek",
  AMD: "֏",
  ARS: "AR$",
  AUD: "AU$",
  AZN: "₼",
  BAM: "KM",
  BDT: "৳",
  BIF: "FBu",
  BND: "BN$",
  BOB: "Bs",
  BRL: "R$",
  BWP: "P",
  BYN: "Br",
  BZD: "BZ$",
  CDF: "FrCD",
  CHF: "CHF",
  CLP: "CL$",
  CNY: "CN¥",
  COP: "CO$",
  CRC: "₡",
  CVE: "CV$",
  CZK: "Kč",
  DJF: "Fdj",
  DKK: "kr",
  DOP: "RD$",
  ERN: "Nfk",
  ETB: "Br",
  GBP: "£",
  GEL: "₾",
  GHS: "GH₵",
  GNF: "FG",
  GTQ: "Q",
  HKD: "HK$",
  HNL: "L",
  HUF: "Ft",
  IDR: "Rp",
  ILS: "₪",
  INR: "₹",
  IRR: "IRR",
  ISK: "kr",
  JMD: "J$",
  JPY: "￥",
  KES: "Ksh",
  KHR: "៛",
  KMF: "FC",
  KRW: "₩",
  KZT: "₸",
  LKR: "SL Re",
  MDL: "lei",
  MGA: "MGA",
  MKD: "MKD",
  MMK: "K",
  MOP: "MOP$",
  MUR: "₨",
  MXN: "MXN$",
  MYR: "RM",
  MZN: "MTn",
  NAD: "N$",
  NGN: "₦",
  NIO: "C$",
  NOK: "kr",
  NPR: "रु",
  NZD: "NZ$",
  PAB: "B/.",
  PEN: "S/.",
  PHP: "₱",
  PKR: "₨",
  PLN: "zł",
  PYG: "₲",
  RON: "RON",
  RSD: "RSD",
  RUB: "₽",
  RWF: "FR",
  SDG: "SDG",
  SEK: "kr",
  SGD: "S$",
  SOS: "Ssh",
  THB: "฿",
  TOP: "T$",
  TRY: "TL",
  TTD: "TT$",
  TWD: "NT$",
  TZS: "TSh",
  UAH: "₴",
  UGX: "USh",
  UYU: "$U",
  UZS: "сум",
  VND: "₫",
  XAF: "FCFA",
  XOF: "CFA",
  ZAR: "R",
  ZMW: "K",
  ZWL: "ZWL$",
};

// $ is replaced with the currency symbol, 1 is replaced with the amount
// default "$1"
export const CURRENCY_SYMBOL_POSITION: Record<string, string> = {
  ALL: "1 $",
  BAM: "1 $",
  BYN: "1 $",
  CZK: "1 $",
  DKK: "1 $",
  GEL: "1 $",
  HUF: "1 $",
  ISK: "1 $",
  IRR: "1 $",
  KHR: "1$",
  MDL: "1 $",
  MKD: "1 $",
  NOK: "1 $",
  PLN: "1 $",
  RON: "1 $",
  RSD: "1 $",
  RUB: "1$",
  SEK: "1 $",
  UZS: "1 $",
  VND: "1$",
};

// only list currencies that have more than 2 decimals
export const CURRENCY_SYMBOL_DECIMALS: Record<string, number> = {
  BHD: 3,
  JOD: 3,
  KWD: 3,
  LYD: 3,
  OMR: 3,
  TND: 3,
};
